import { Copy, RefreshCw } from "lucide-react";
import { useState } from "react";

const WalletBalance = ({ address, balance, tokens = [], onRefresh }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <>
      {address && (
        <div className="bg-white/70 dark:bg-slate-900/70 backdrop-blur-md rounded-3xl shadow-2xl p-6 w-full max-w-[36%] mx-auto border border-emerald-100 dark:border-slate-700">
          {/* Header */}
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 to-cyan-500">
              Wallet Balance
            </h2>
            <button
              onClick={onRefresh}
              className="bg-white dark:bg-slate-800 p-2 rounded-full border border-emerald-200 dark:border-slate-600 text-emerald-600 hover:shadow-md hover:scale-105 transition-all"
            >
              <RefreshCw className="h-4 w-4" />
              <span className="sr-only">Refresh</span>
            </button>
          </div>

          {/* Wallet Address */}
          <div className="mb-6">
            <label className="text-emerald-600 dark:text-emerald-300 text-sm font-medium mb-2 block">
              Wallet Address
            </label>
            <div className="flex items-center gap-2">
              <div className="bg-white dark:bg-slate-800 text-gray-700 dark:text-gray-200 p-3 rounded-xl text-sm border border-gray-100 dark:border-slate-700 shadow-sm font-mono truncate overflow-hidden whitespace-nowrap w-full">
                {address}
              </div>
              <button
                onClick={copyToClipboard}
                className="flex items-center gap-2 bg-emerald-50 dark:bg-slate-700 hover:bg-emerald-100 dark:hover:bg-slate-600 text-emerald-700 dark:text-emerald-300 text-sm px-3 py-3 rounded-lg border border-emerald-200 dark:border-slate-600 transition-all"
              >
                <Copy className="w-4 h-4" />
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
          </div>

          {/* Token List */}
          <div className="space-y-3 max-h-[210px] overflow-y-auto scrollbar-none pr-1">
            {tokens.map((token, idx) => (
              <div
                key={idx}
                className="bg-white dark:bg-slate-800 rounded-xl p-4 flex justify-between items-center border border-gray-100 dark:border-slate-700 shadow-sm hover:shadow-md transition-all"
              >
                <div className="flex items-center gap-3">
                  <div className="bg-gradient-to-r from-emerald-500 to-cyan-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm">
                    {token.symbol}
                  </div>
                  <span className="text-gray-800 dark:text-white font-bold">
                    {token.balance}
                  </span>
                </div>
                <div className="text-gray-500 dark:text-gray-400 text-sm">
                  {token.name}
                </div>
              </div>
            ))}

            {tokens.length === 0 && (
              <div className="bg-white dark:bg-slate-800 rounded-xl p-4 text-center text-gray-500 dark:text-gray-400 border border-gray-100 dark:border-slate-700">
                No tokens found in wallet
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default WalletBalance;
